export const PRO_PURCHASE_URL = 'https://pay.omniafishing.com/b/bIY6pf1fy5bC3PWaEE';
export const PRO_TRIAL_PURCHASE_URL = 'https://pay.omniafishing.com/b/aEU3d3bUcavWdqwbIK';
// credit purchase urls urls
export const PRO_PURCHASE_CREDIT_URL = 'https://pay.omniafishing.com/b/4gw3d3cYg5bC4U03cg';
export const PRO_TRIAL_CREDIT_URL = 'https://pay.omniafishing.com/b/3cs14V5vO1ZqfyE8wz';

export const CORE_PURCHASE_URL = 'https://pay.omniafishing.com/b/eVq3cu5ii5jveFYaWv3wQ07';
export const CORE_TRIAL_PURCHASE_URL = 'https://pay.omniafishing.com/b/5kQbJ09yy5jvcxQ2pZ3wQ08';

//  test mode urls
export const CORE_PURCHASE_TEST_URL =
  'https://pay.omniafishing.com/b/test_4gM00i6mmbHT7dw0hR3wQ02';
export const CORE_TRIAL_PURCHASE_TEST_URL =
  'https://pay.omniafishing.com/b/test_14AdR85iidQ18hA1lV3wQ03';
export const PRO_PURCHASE_TEST_URL = 'https://pay.omniafishing.com/b/test_bIY4hU1WrbuC6KQ3cd';
export const PRO_TRIAL_PURCHASE_TEST_URL =
  'https://pay.omniafishing.com/b/test_8x26oGfWWh2dbtM7Kj3wQ04';

export const proPaymentLinkUrls = [
  PRO_PURCHASE_URL,
  PRO_TRIAL_PURCHASE_URL,
  PRO_PURCHASE_CREDIT_URL,
  PRO_TRIAL_CREDIT_URL,
  PRO_PURCHASE_TEST_URL,
  PRO_TRIAL_PURCHASE_TEST_URL,
];
export const proTrialPaymentLinkUrls = [PRO_TRIAL_PURCHASE_URL, PRO_TRIAL_CREDIT_URL];

export const corePaymentLinkUrls = [
  CORE_PURCHASE_URL,
  CORE_TRIAL_PURCHASE_URL,
  CORE_PURCHASE_TEST_URL,
  CORE_TRIAL_PURCHASE_TEST_URL,
];
export const coreTrialPaymentLinkUrls = [
  CORE_TRIAL_PURCHASE_URL,
  CORE_TRIAL_PURCHASE_TEST_URL,
];

